module.exports = __webpack_public_path__ + "static/img/m_ph01.b859058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/m_ph01.jpg
// module id = 2p/9
// module chunks = 0